import type { Achievement, Provenance } from '@losan/core';
import { DemoBadge } from './DemoBadge.js';

interface Props {
  achievements: Achievement[];
  provenance: Provenance;
}

/**
 * Badges with an inline glossary: each card shows how the badge is unlocked
 * directly under the label, so the agent never has to wonder what counts.
 */
export function BadgesPanel({ achievements, provenance }: Props) {
  return (
    <div className="section">
      <h2>
        Logros
        <DemoBadge provenance={provenance} />
      </h2>
      <div className="badges-grid">
        {achievements.map((a) => (
          <div key={a.id} className={`badge ${a.unlocked ? 'unlocked' : ''}`}>
            <div className="badge-head">
              <span className="badge-medal" aria-hidden="true">
                {a.unlocked ? '★' : '☆'}
              </span>
              <span className="badge-label">{a.label}</span>
            </div>
            <div className="badge-description">{a.description}</div>
            <div className="badge-progress" aria-label={`${Math.round(a.progress * 100)}% completado`}>
              <div style={{ width: `${Math.min(100, Math.max(0, a.progress * 100))}%` }} />
            </div>
            <div className="badge-meta">
              {a.unlocked ? 'Desbloqueado' : `${Math.round(a.progress * 100)}% completado`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
